import {
  EventDeleteMessagesPayload,
  EventEditMessagePayload,
  IMessage,
} from '@weblite/ts-action/message'
import { sendPushRegisterToken } from '@weblite/ts-action/push'
import { postMessageToFirebaseSWR } from '$setup/notification'
import { send } from '$setup/ws'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'

export function sendFcmTokenToServer(token: string) {
  send(sendPushRegisterToken({ token }), true, -1)
}

function updateRoomNotifications(
  action: { roomId: string } & (
    | {
        type: TWA_EVENTS.EDIT_NOTIFICATION
        iid: number
        patch: Pick<IMessage, 'body' | 'attachment'>
      }
    | { type: TWA_EVENTS.DELETE_NOTIFICATION; iids: number[] }
    | { type: TWA_EVENTS.SEEN_NOTIFICATION; iid: number }
  ),
) {
  postMessageToFirebaseSWR(action)
  const { type, ...payload } = action
  sendEventToTwa(type, payload)
}

export function handleEditMessageNotification({
  iid,
  roomId,
  ...other
}: EventEditMessagePayload) {
  updateRoomNotifications({
    roomId,
    iid,
    type: TWA_EVENTS.EDIT_NOTIFICATION,
    patch: other,
  })
}

export function handleDeleteMessagesNotification({
  iids,
  roomId,
}: EventDeleteMessagesPayload) {
  updateRoomNotifications({
    roomId,
    iids,
    type: TWA_EVENTS.DELETE_NOTIFICATION,
  })
}

const sentSeenEvents: Record<string, number> = {}
export function handleSeenMessagesNotification(roomId: string, iid: number) {
  if (sentSeenEvents[roomId] > iid) return

  sentSeenEvents[roomId] = iid
  updateRoomNotifications({ roomId, type: TWA_EVENTS.SEEN_NOTIFICATION, iid })
}
